"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useActiveDescendantId;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useActiveDescendantId() {
  return (0, _useContext.default)().activeDescendantIdState;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VBY3RpdmVEZXNjZW5kYW50SWQiLCJ1c2VUcmFuc2NyaXB0Rm9jdXNDb250ZXh0IiwiYWN0aXZlRGVzY2VuZGFudElkU3RhdGUiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wcm92aWRlcnMvVHJhbnNjcmlwdEZvY3VzL3VzZUFjdGl2ZURlc2NlbmRhbnRJZC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlVHJhbnNjcmlwdEZvY3VzQ29udGV4dCBmcm9tICcuL3ByaXZhdGUvdXNlQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZUFjdGl2ZURlc2NlbmRhbnRJZCgpOiByZWFkb25seSBbc3RyaW5nXSB7XG4gIHJldHVybiB1c2VUcmFuc2NyaXB0Rm9jdXNDb250ZXh0KCkuYWN0aXZlRGVzY2VuZGFudElkU3RhdGU7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLHFCQUFULEdBQW9EO0VBQ2pFLE9BQU8sSUFBQUMsbUJBQUEsSUFBNEJDLHVCQUFuQztBQUNEIn0=